import { render } from "./users-list.vue?vue&type=template&id=4a923fc2"
import script from "./users-list.vue?vue&type=script&lang=js"
export * from "./users-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__